













import { indexOf } from "lodash";

export default {
    name: "AutoRefresh",
    props: {
        refreshFunction: Function,
        pauseRefresh: Boolean,
    },
    data() {
        return {
            refreshTime: 120,
            oldRefreshTime: null,
            refreshValues: [0, 30, 60, 120],
            timer: null,
        };
    },
    created() {
        // Onglet caché : plus de rafraîchissement (chaque liste ouverte
        // rechargeait sa page complète toutes les minutes en arrière-plan).
        document.addEventListener("visibilitychange", this.onVisibilityChange);
    },
    methods: {
        toggleRefresh() {
            let i = indexOf(this.refreshValues, this.refreshTime);
            this.refreshTime =
                this.refreshValues[(i + 1) % this.refreshValues.length];
        },
        cancelAutoUpdate() {
            clearInterval(this.timer);
        },
        startAutoUpdate() {
            this.cancelAutoUpdate();
            if (this.refreshTime > 0 && !document.hidden) {
                this.timer = setInterval(
                    this.refreshFunction,
                    this.refreshTime * 1000
                );
            }
        },
        onVisibilityChange() {
            if (document.hidden) {
                this.cancelAutoUpdate();
            } else if (this.refreshTime > 0) {
                this.refreshFunction();
                this.startAutoUpdate();
            }
        },
    },
    watch: {
        refreshTime: {
            immediate: true,
            handler: function () {
                this.startAutoUpdate();
            },
        },
        pauseRefresh: {
            immediate: true,
            handler: function () {
                if (this.pauseRefresh) {
                    this.oldRefreshTime = this.refreshTime;
                    this.refreshTime = 0;
                } else if (this.oldRefreshTime) {
                    this.refreshTime = this.oldRefreshTime;
                }
            },
        },
    },
    destroyed() {
        this.cancelAutoUpdate();
        document.removeEventListener(
            "visibilitychange",
            this.onVisibilityChange
        );
    },
};
